module.exports = __webpack_public_path__ + "static/media/wlhy_bg.add11739.png";